import { microserviceApiAxios } from "../../microservice-api.axios";
import { microserviceApiRoutes } from "../../microservice-api.routes";

export const loginPolicy = (clientId: string) => {
  const url = microserviceApiRoutes.v1.policy.auth.login(clientId);
  return microserviceApiAxios.get(url).then((res) => res);
};
